import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import moment from "moment";
import dayjs from "dayjs";


const ShiftInstructionModal = ({ mode, handleCloseClick,editData }) => {
  const [parentId, setParentId] = useState([]);
  const [loading,setLoading]=useState(false)

//   useEffect(() => {
//    getData()
//   }, []);

//   const getData=async()=>{
//     setLoading(true)
//     const link = masterAPI["assetCategory"].link;
//    await axiosPrivate
//       .get(`${link}`)
//       .then((res) => {
//         setLoading(false)
//         setParentId(res.data.result);
//       })
//       .catch((e) => {
//         setLoading(false)
//         setParentId([])
//         console.log(e, "createACgetAll");
//       });
//   }

//   const initialValue = {
//     code: mode==="Edit"?editData.code: "",
//     assetCategoryName: mode==="Edit"?editData.assetCategoryName: "",
//     // parentCategoryId:mode==="Edit"?editData.parentCategoryId: null,
//   };

//   const onSubmit = async(value) => {
//     console.log(value);
//     setLoading(true)
//     const createLink = masterAPI["assetCategory"].create;
//     const updateLink=masterAPI["assetCategory"].update
//     if(mode==="Create"){
//      await axiosPrivate.post(`${createLink}`,value).then(res=>{
//         console.log(res.data)
//         setLoading(false)
//         handleCloseClick()
//       }).catch(e=>{
//         setLoading(false)
//         console.log(e,"createAC")
//       })
//     }else{
//       const updateAC={
//         id:editData.id,
//         ...value
//       }
//      await axiosPrivate.put(`${updateLink}`,updateAC).then(res=>{
//         console.log(res.data)
//         setLoading(false)
//         handleCloseClick()
//       }).catch(e=>{
//         setLoading(false)
//         console.log(e,"updateAC")
//       })
//     }
   
//   };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding}}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          Shift Instruction
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{border:"1px solid rgb(0 0 0 / 17%)",mb:"15px"}} />
      <Formik  >
      {({ handleChange, setFieldValue, values , resetForm }) => (
        <Form>
          <Grid container spacing={"1rem"}>
          <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Instruction Key
                </Typography>
              <TextField
                size={"small"}
                value={"00005"}
                type="text"
                placeholder="Enter Insstruction Key"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Create Date Time
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY hh:mm"
                      value={dayjs("2020-01-31T09:35")}
                      readOnly
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                    //   onChange={(newValue) => {
                    //     console.log(newValue);
                    //     if (newValue !== null) {
                    //       if (`${newValue.$d}` !== "Invalid Date") {
                    //         const dateFrom = moment(newValue.$d).format(
                    //           "YYYY-MM-DD"
                    //         );
                    //         const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                    //         const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                    //         const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                    //         const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                    //         setFieldValue("installationDate", dateFormat);
                    //       }
                    //     }
                    //   }}
                    />
                  </DemoItem>
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} >
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Instruction Name
                </Typography>
              <TextField
                size={"small"}
                value={"Long term work pending"}
                type="text"
                placeholder="Enter Insstruction Name"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Valid From Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={dayjs("2020-01-30")}
                      readOnly
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                    //   onChange={(newValue) => {
                    //     console.log(newValue);
                    //     if (newValue !== null) {
                    //       if (`${newValue.$d}` !== "Invalid Date") {
                    //         const dateFrom = moment(newValue.$d).format(
                    //           "YYYY-MM-DD"
                    //         );
                    //         const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                    //         const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                    //         const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                    //         const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                    //         setFieldValue("installationDate", dateFormat);
                    //       }
                    //     }
                    //   }}
                    />
                  </DemoItem>
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Valid To Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={dayjs("2020-09-30")}
                      readOnly
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                    //   onChange={(newValue) => {
                    //     console.log(newValue);
                    //     if (newValue !== null) {
                    //       if (`${newValue.$d}` !== "Invalid Date") {
                    //         const dateFrom = moment(newValue.$d).format(
                    //           "YYYY-MM-DD"
                    //         );
                    //         const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                    //         const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                    //         const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                    //         const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                    //         setFieldValue("installationDate", dateFormat);
                    //       }
                    //     }
                    //   }}
                    />
                  </DemoItem>
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} >
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Description
                </Typography>
              <TextField
                size={"small"}
                value={"Some work that has been planned in future"}
                type="text"
                multiline
                minRows={3}
                

                placeholder="Enter Description"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} >
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Created By
                </Typography>
              <TextField
                size={"small"}
                value={"Supervisor"}
                type="text"
                placeholder="Enter Insstruction Name"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
               <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 Instruction Status
                </Typography>
                
              <Select
                // label={"Select"}
                size={"small"}
                readOnly
                type="text"
                value={'1'}
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
            //    renderValue={values.parentCategoryId !== null ? undefined : () =><Typography sx={{  color: color.placeholderColor,
            //     fontSize: "13px",}} >Select</Typography> }
              >
               
                
                  <MenuItem value={"1"} >
                    VALID
                    </MenuItem>
              
              </Select>
            </Grid>
            <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
              <Button
                onClick={handleCancel}
                variant="contained"
                sx={{
                  backgroundColor: color.TableCancelButton,
                  textTransform: "none",
                  color: color.CancelTextColor,
                  ":hover":{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                type={"submit"}
                variant="contained"
                disabled={loading}
                sx={{
                      
                  textTransform: "none",
                  backgroundColor: loading ? "default" : color.TableButtonColor,
                  "&:hover": {
                    backgroundColor: loading
                      ? "default"
                      : color.buttonDisable,
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
      </Formik>
    </Box>
  );
};

export default ShiftInstructionModal; 
